import {
    CLEAR_MESSAGE, CLEAR_MESSAGE_ERROR, EMPTY_MESSAGING,
    FETCH_CONVERSATIONS, FETCH_CONVERSATIONS_SUCCESS, FETCH_CONVERSATIONS_FAILURE,
    FETCH_MESSAGES, FETCH_MESSAGES_SUCCESS, FETCH_MESSAGES_FAILURE,
    MARK_CONVERSATION_READ, MARK_CONVERSATION_READ_SUCCESS, MARK_CONVERSATION_READ_FAILURE,
    SEND_MESSAGE, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_FAILURE,
    SET_CONVERSATION, SET_MESSAGE, SET_SUBJECT
} from './constants';

const initialState = {
    conversations: [],
    conversation: {},
    hasUnreadMessages: false,
    messages: [],
    message: '',
    subject: '',
    isFetchingConversations: false,
    isFetchingMessages: false,
    isSending: false,
    error: {},
    conversationsError: {},
    messagesError: {},
    messageError: {}
};

function messagingReducer(state = initialState, action) {
    switch(action.type) {
        case CLEAR_MESSAGE:
            return Object.assign({}, state, {
                message: '',
                subject: ''
            });
        case CLEAR_MESSAGE_ERROR:
            return Object.assign({}, state, {
                messageError: {}
            });
        case EMPTY_MESSAGING:
            return initialState;
        case FETCH_CONVERSATIONS:
            return Object.assign({}, state, {
                isFetchingConversations: action.hideSpinner !== true,
                conversationsError: {}
            });
        case FETCH_CONVERSATIONS_SUCCESS:
            return Object.assign({}, state, {
                isFetchingConversations: false,
                conversations: action.data,
                hasUnreadMessages: action.hasUnreadMessages === true
            });
        case FETCH_CONVERSATIONS_FAILURE:
            return Object.assign({}, state, {
                isFetchingConversations: false,
                conversationsError: action.error
            });
        case FETCH_MESSAGES:
            return Object.assign({}, state, {
                isFetchingMessages: action.hideSpinner !== true,
                messagesError: {}
            });
        case FETCH_MESSAGES_SUCCESS:
            return Object.assign({}, state, {
                isFetchingMessages: false,
                messages: action.data
            });
        case FETCH_MESSAGES_FAILURE:
            return Object.assign({}, state, {
                isFetchingMessages: false,
                messagesError: action.error
            });
        case MARK_CONVERSATION_READ:
            return Object.assign({}, state, {
                isMarkingRead: true,
                error: {}
            });
        case MARK_CONVERSATION_READ_SUCCESS:
            return Object.assign({}, state, {
                isMarkingRead: false
            });
        case MARK_CONVERSATION_READ_FAILURE:
            return Object.assign({}, state, {
                isMarkingRead: false,
                error: action.error
            });
        case SEND_MESSAGE:
            return Object.assign({}, state, {
                isSending: true,
                messageError: {}
            });
        case SEND_MESSAGE_SUCCESS:
            return Object.assign({}, state, {
                isSending: false,
                message: ''
            });
        case SEND_MESSAGE_FAILURE:
            return Object.assign({}, state, {
                isSending: false,
                messageError: action.error
            });
        case SET_CONVERSATION:
            return Object.assign({}, state, {
                conversation: action.data
            });
        case SET_MESSAGE:
            return Object.assign({}, state, {
                message: action.data
            });
        case SET_SUBJECT:
            return Object.assign({}, state, {
                subject: action.data
            });
        default:
            return state;
    }
}

export default messagingReducer;



// WEBPACK FOOTER //
// ./src/containers/Messaging/store/reducers.js